// v1.0.4 - Add Back button to dashboard header
import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import { enUS } from "@clerk/localizations";
import "./index.css";
import App from "./App";
import AppNoClerk from "./AppNoClerk";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

// Use English localization, but strengthen the legal consent note under the
// Terms of Service & Privacy Policy checkbox.
const localization = {
  ...enUS,
  signUp: {
    ...enUS.signUp,
    legalConsent: {
      ...enUS.signUp?.legalConsent,
      continue: {
        ...enUS.signUp?.legalConsent?.continue,
        subtitle: "Please confirm you agree to the Terms of Service and Privacy Policy.",
      },
    },
  },
};

// Allow app to render without Clerk in environments where the publishable key
// isn't configured yet (e.g., preview deploys or local quick tests).
const Tree = CLERK_PUBLISHABLE_KEY ? (
  <ClerkProvider 
    publishableKey={CLERK_PUBLISHABLE_KEY}
    localization={localization}
    appearance={{
      variables: {
        colorPrimary: '#667eea',
        colorText: '#1f2937',
        colorBackground: '#ffffff',
        colorInputBackground: '#ffffff',
        colorInputText: '#1f2937'
      },
      elements: {
        formButtonPrimary: 'bg-purple-600 hover:bg-purple-700 text-white',
        card: 'shadow-lg',
        headerTitle: 'text-2xl font-bold',
        headerSubtitle: 'text-gray-600'
      }
    }}
  >
    <App />
  </ClerkProvider>
) : (
  <AppNoClerk />
);

root.render(Tree);

reportWebVitals();
